var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("autocomplete-input", {
    attrs: {
      "class-name": "fe-address-autocomplete main-address",
      disabled: _vm.disabled,
      "raw-value": _vm.addressString,
      "clear-after": false,
      "hold-input-value": "",
    },
    on: { change: _vm.handleChange, "value-change": _vm.handleChange },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }